import { createContext } from "react";

export const LoginContext = createContext({});

export const FarmerContext = createContext({});


